import { useSyncExternalStore } from 'react'
import { appConfig } from '@/shared/config/app-config'

const STORAGE_PREFIX = `${appConfig.storagePrefix}_day_completed_`

const listeners = new Set<() => void>()

function notify() {
  for (const l of listeners) l()
}

function subscribe(cb: () => void) {
  listeners.add(cb)
  return () => listeners.delete(cb)
}

export function markBannerEligible(userId: string) {
  localStorage.setItem(`${STORAGE_PREFIX}${userId}`, 'true')
  notify()
}

export function useBannerEligible(userId: string | undefined): boolean {
  return useSyncExternalStore(
    subscribe,
    () =>
      userId
        ? localStorage.getItem(`${STORAGE_PREFIX}${userId}`) === 'true'
        : false,
    () => false,
  )
}
